import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/tope-sbc-imss';

/**
 * GET Topes SBC IMSS
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTopesSbcImss = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tope SBC IMSS
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTopeSbcImss = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tope SBC IMSS
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTopeSbcImss = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tope SBC IMSS
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTopeSbcImss = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tope SBC IMSS
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTopeSbcImss = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Tope SBC IMSS
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarTopeSbcImss = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, {
      estados_globales: ESTATUS_AUTORIZADO,
    });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
